import { DecorationModel } from "../_model/DecorationModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors";
import * as d3 from "d3";

export class DecorationInput extends DecorationModel {
  constructor() {
    super("DecorationInput");
    this.node = null;

    this.init = async function(newNode, openDialog) {
      let svg = SingletonFlowchart.svg;
      this.node = newNode;
      this.dialog = openDialog;

      await svg
        .data([newNode])
        .append("g")
        .classed("Input", true)
        .attr("id", `Input-${newNode.id}`)
        .style("cursor", "pointer")
        .call(this.setDrag());

      let g = d3.select(`#Input-${newNode.id}`);

      g.append("rect")
        .classed("Input", true)
        .attr("x", (d) => d.x)
        .attr("y", (d) => d.y)
        .attr("stroke", COLORS.OrangePentagro1)
        .style("fill", "#0000")
        .style("width", newNode.width)
        .style("height", newNode.height)
        .on("dblclick", this.setDoubleClick)
        .on("click", this.setOnClick)
        .node();

      g.append("path")
        .attr("d", (d) => d.pathLineCenter())
        .attr("stroke", COLORS.OrangePentagro1)
        .on("dblclick", this.setDoubleClick)
        .on("click", this.setOnClick);

      g.append("text")
        .classed("InputTitle", true)
        .attr("y", (d) => d.y + newNode.heightText)
        .attr("x", (d) => d.xText())
        .attr("text-anchor", "middle")
        .style("stoke", COLORS.Black90)
        .text(newNode.title)
        .on("dblclick", this.setDoubleClick)
        .on("click", this.setOnClick)
        .node();

      let n = newNode.data[0];
      d3.selectAll(`#${newNode.idName} > text.current-attr`).remove();
      g.append("text")
        .attr("id", `${n.id}`)
        .classed("current-attr", true)
        .attr("y", (d) => n.y(d.y + newNode.heightValue))
        .attr("x", (d) => d.xText())
        .attr("text-anchor", "middle")
        .style("stoke", COLORS.Black90)
        .text(n.text())
        .on("dblclick", this.setDoubleClick)
        .on("click", this.setOnClick)
        .node();

      return svg;
    };

    this.setDrag = function() {
      if (this.node.readOnly) return d3.drag();

      let that = this;
      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d, that))
        .on("end", (event, d) => that.dragended(event, d, that));

      return drag;
    };

    this.dragstarted = function(event, d) {
      SingletonFlowchart.clicked = true;
      SingletonFlowchart.selectNode(d.idName);

      d3.select(`#${d.idName}`).style("cursor", "grabbing");
    };

    this.dragged = async function(event, d, that) {
      SingletonFlowchart.clicked = false;

      d.x = event.x;
      d.y = event.y;

      that.move();
    };

    this.move = async () => {
      let d = this.node;
      d3.select(`#${d.idName} > rect`)
        .raise()
        .attr("x", d.x)
        .attr("y", d.y);
      d3.select(`#${d.idName} > text.InputTitle`)
        .raise()
        .attr("x", d.xText())
        .attr("y", d.y + d.heightText);
      d3.select(`#${d.idName} > path`)
        .raise()
        .attr("d", d.pathLineCenter());
      let n = d.data[0];
      d3.select(`#${d.idName} > text.current-attr`)
        .raise()
        .attr("x", d.xText())
        .attr("y", n.y(d.y + d.heightValue));
    };

    this.dragended = function(event, d) {
      d3.select(`#${d.idName}`).style("cursor", "grab");

      SingletonFlowchart.SaveStatus();
    };

    this.reloadProperties = () => {
      this.setTextAndAdjustWidth()
    };

    this.setTextAndAdjustWidth = function (){
      let d = this.node;

      d3.select(`#${d.idName} > rect`).style("width", d.width);

      d3.select(`#${d.idName} > path`).attr("d", d.pathLineCenter());

      d3.select(`#${d.idName} > text.InputTitle`)
        .attr("x", d.xText())
        .text(d.title)
        .node();

      d3.selectAll(`#${d.idName} > text.current-attr`).remove();

      let n = d.data[0]

      let g = d3.select(`#${d.idName}`);
      g.append("text")
        .attr("id", n.id)
        .classed("current-attr", true)
        .attr("x", d.xText())
        .attr("y", n.y(d.y + d.heightValue))
        .attr("text-anchor", "middle")
        .style("stoke", COLORS.Black90)
        .text(n.value)
        .on("dblclick", () => this.dialog(d))
        .on("click", this.setOnClick);
    };

    this.setReadyOnly = () => {
      return;
    };
  }
}
